'use client';

import { Plus } from 'lucide-react';
import type { PublicMenuItem, UpsellSuggestion } from '@/types/menu-sales';

type Props = {
  suggestions: UpsellSuggestion[];
  onAdd: (item: PublicMenuItem) => void;
  onDismiss?: (ruleId: string) => void;
  compact?: boolean;
};

export function CartSuggestions({ suggestions, onAdd, onDismiss, compact }: Props) {
  if (suggestions.length === 0) return null;

  return (
    <div className={`order-suggestions ${compact ? 'order-suggestions-compact' : ''}`}>
      {suggestions.map((group) => (
        <div key={group.rule_id} className="order-suggestion-group">
          <div className="order-suggestion-header">
            <p className="order-suggestion-message">{group.message}</p>
            {onDismiss && (
              <button
                type="button"
                onClick={() => onDismiss(group.rule_id)}
                className="order-suggestion-dismiss"
                aria-label="Ignorar sugestao"
              >
                ×
              </button>
            )}
          </div>
          <div className="order-suggestion-items">
            {group.items.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => onAdd(item)}
                className="order-suggestion-chip"
              >
                <span className="order-suggestion-chip-name">{item.name}</span>
                <span className="order-suggestion-chip-price">{Number(item.price).toFixed(2)} €</span>
                <Plus className="w-3.5 h-3.5 shrink-0" aria-hidden />
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
